import { DomainEvent } from '@withlocals/cqrs.js';

export interface TokenApiResult {
  current: string;
  loggedInAs: string;
  authenticator: {
    creationDate: number;
    expirationDate: number;
    id: string;
    lastUsed: number;
  };
}

export interface LoginApiResult {
  account: {
    id: string;
    preferredLang: string;
  };
  authenticator: {
    creationDate: number;
    expirationDate: number;
    id: string;
    lastUsed: number;
  };
}

export abstract class AuthEvent implements DomainEvent {
}

export class AuthenticatedEvent extends AuthEvent {
  constructor(readonly result: LoginApiResult) {
    super();
  }
}

export class NotAuthenticatedEvent extends AuthEvent {
}

export class PasswordResetEvent extends AuthEvent {
}

export class AuthenticationErrorEvent extends AuthEvent {
  readonly error: string;

  constructor(readonly errorInput: any) {
    super();
    this.error = errorInput?.xhr?.response?.error || errorInput.toString();
  }

  pretty(): string {
    if (!this.error) {
      return null;
    }
    if (this.error.indexOf('HasFacebookLogin') > -1) {
      return 'This email was registered through Facebook. Please log in through Facebook again';
    }
    if (this.error.indexOf('IncorrectPassword') > -1) {
      return 'Your password does not match with your email';
    }
    if (this.error.indexOf('EmailUnknown') > -1) {
      return 'Email does not exist. Please use an existing email or sign up below';
    }
    if (this.error.indexOf('EmailAddressAlreadyRegistered') > -1) {
      return 'Looks like you already have an account. We sent you an email to set your password.';
    }
    if (this.error.indexOf('EmailAddressInvalid') > -1) {
      return 'Please fill in a valid email address';
    }
    if (this.error.indexOf('IsOtherGuestThatNeedsActivation') > -1) {
      return 'Follow the activation link you received in your inbox at the time of the booking in order to login/signup';
    }
    if (this.error.indexOf('User cancelled') > -1) {
      return 'Facebook login was rejected by you. Please login with Facebook or with email to proceed.';
    }
    return this.error;
  }

}

export class AuthenticationChangedEvent extends AuthEvent {
}
